module.exports = __webpack_public_path__ + "img/MenuWhiteIcon.ef5949fd.svg";